export const GET_LEGALS = 'legals/GET_LEGALS';
export const getLegalsAction = payload => ({
	type: GET_LEGALS,
	payload,
});

export const SET_LEGALS = 'legals/SET_LEGALS';
export const setLegalsAction = payload => ({
	type: SET_LEGALS,
	payload,
});

export const SET_IS_LEGALS_LOADING = 'legals/SET_IS_LEGALS_LOADING';
export const setIsLegalsLoadingAction = payload => ({
	type: SET_IS_LEGALS_LOADING,
	payload,
});

export const SET_IS_DOWNLOAD_LOADING = 'legals/SET_IS_DOWNLOAD_LOADING';
export const setIsDownloadLoadingAction = payload => ({
	type: SET_IS_DOWNLOAD_LOADING,
	payload,
});

export const SET_LEGALS_SEARCH_VALUE = 'legals/SET_LEGALS_SEARCH_VALUE';
export const setLegalsSearchValueAction = payload => ({
	type: SET_LEGALS_SEARCH_VALUE,
	payload,
});

export const SET_PAGINATION = 'legals/SET_PAGINATION';
export const setPaginationAction = payload => ({
	type: SET_PAGINATION,
	payload,
});

export const RESET_STATE = 'legals/RESET_STATE';
export const resetStateAction = () => ({
	type: RESET_STATE,
});

export const GET_LIST_LEGAL_FILE_TYPES = 'legals/GET_LIST_LEGAL_FILE_TYPES';
export const getListLegalFileAction = payload => ({
	type: GET_LIST_LEGAL_FILE_TYPES,
	payload,
});
